<template>
  <div>
    <!-- 位置名称 动态 -->
    <bread-crumb></bread-crumb>
    <div class="rumor-search-box">
      <p class="rumor-tip">请先选择业务ID，再对谣言进行处理操作</p>
      <el-form ref="rumor-search-form" :model="form" label-width="90px" class="rumor-search">
        <el-form-item label="业务ID">
          <el-select
            clearable
            v-model="contentBusinessId"
            @change="changeSelect"
            placeholder="请选择业务ID"
          >
            <el-option
              v-for="ele in contentBusinesses"
              :key="ele.id"
              :label="ele.name"
              :value="ele.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="谣言检索">
          <el-input style="width: 200px" v-model="form.seqNumber" placeholder="请输入谣言id进行检索"></el-input>
        </el-form-item>
        <el-form-item label="标题检索">
          <el-input style="width: 200px" v-model="form.title" placeholder="请输入谣言标题进行检索"></el-input>
        </el-form-item>
        <el-form-item label="投放时间">
          <el-date-picker
            v-model="form.submissionTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00', '23:59:59']"
            value-format=" yyyy/MM/dd"
            format="yyyy/MM/dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button @click="reset">重置</el-button>
          <el-button type="primary" @click="onSumit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="pgcQa-iebtns">
      <el-button size="small" type="primary" @click="multiUpload">批量上传</el-button>
      <el-button size="small" type="primary" @click="addRumor">添加谣言</el-button>
    </div>
    <div class="pgcQa--tabel">
      <div class="base-table">
        <div class="base-table-table">
          <el-table :data="pgcQaList" :border="true" stripe>
            <el-table-column
              prop="code"
              label="组ID"
            >
            </el-table-column>
            <el-table-column
              prop="seqNumber"
              label="谣言ID"
            >
            </el-table-column>
            <el-table-column
              label="谣言时间"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.showTime ? new Date(scope.row.showTime).toLocaleDateString() : ''}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="title"
              label="谣言标题"
            >
            </el-table-column>
            <el-table-column
              prop="imgUrl"
              label="图片"
              width="80"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.imgUrl">
                  <el-tooltip :content="scope.row.imgUrl" placement="top">
                    <el-image
                      :src="scope.row.imgUrl"
                      :preview-src-list="[scope.row.imgUrl]"
                      style="width: 50px; height: 50px; border-radius: 4px; cursor: pointer;"
                      fit="cover"
                      @error="handleImageError"
                    >
                      <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                      </div>
                    </el-image>
                  </el-tooltip>
                </div>
                <span v-else style="color: #C0C4CC;">暂无图片</span>
              </template>
            </el-table-column>
            <el-table-column
              label="真的/假的"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.answer == 1 ? '真的':'假的'}}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="参与人数"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.answeredCount || 0 }}人</span>
              </template>
            </el-table-column>
            <el-table-column
              label="完成人数"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.prizedCount || 0 }}人</span>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="180">
              <template slot-scope="scope">
                <el-button @click="handleClick(scope.row)" type="text" size="small">{{ scope.row.showTime > new Date().getTime() ? '编辑': '查看'}}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <pagination
      @sizePageChange="paginationChangeProduct"
      :paginationDatas="paginationDataProduct"
    />
    <!-- 批量上传 -->
    <el-dialog title="批量上传" :visible.sync="dialogVisible" width="30%" @close='closeDialog'>
      <el-button :disabled="isButton" type="primary" plain style="display: block;margin: auto"
                 @click="downloadDiles">下载谣言Excel模板
      </el-button>
      <div style="margin-top: 10px;display: flex;justify-content: center;align-items: center">
        <input type="file" @change="fileChange" ref="file"/>
        <el-button type="primary" size="medium" :loading="uploadShow" @click="uploadContentSkusExl" style="width: 93px">
          {{ uploadShow ? '上传中' : '上传' }}
        </el-button>
      </div>
      <div style="margin-top: 10px;text-align: center">
        <p>注： 1、请上传Excel文件，列表不超过1000行</p>
        <p>2、上传过程中请勿刷新</p>
      </div>
    </el-dialog>
    <!-- 添加或编辑谣言 -->
    <el-dialog :title="addFlag ? '添加谣言': '编辑谣言'" :visible.sync="addEditDVisible" width="30%" @close='closeADDialog'>
      <el-form ref="ae-rumor-form" :model="curRumor" label-width="90px">
        <el-form-item label="展示时间">
          <el-date-picker
            v-model="curRumor.showTime"
            type="date"
            :disabled="!addFlag"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="谣言标题">
          <el-input maxlength="30" show-word-limit style="width: 240px" v-model="curRumor.title" placeholder="最多30个字..."></el-input>
        </el-form-item>
        <el-form-item label="真的/假的">
          <!-- <el-radio-group v-model="curRumor.answer" > -->
            <el-radio v-model="curRumor.answer" label="1" :border="true">真的</el-radio>
            <el-radio v-model="curRumor.answer" label="0" :border="true">假的</el-radio>
          <!-- </el-radio-group> -->
        </el-form-item>
        <el-form-item label="谣言解答">
          <el-input maxlength="300" type="textarea" show-word-limit style="width: 240px" v-model="curRumor.answerContent" placeholder="最多300个字..."></el-input>
        </el-form-item>
        <el-form-item label="图片链接">
          <el-input style="width: 240px" v-model="curRumor.imgUrl" placeholder="图片链接..."></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="onCancle">取消</el-button>
          <el-button v-if="addFlag || curRumor.showTime > new Date().getTime()" type="primary" @click="onSubmit">完成</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import breadCrumb from "@/components/wiki/breadCrumb";
import pagination from "@/components/wiki/pagination";

import { queryContentUserManInfo, rumorPageRumor, rumorQueryRumor, rumorUpdateRumor, rumorSaveRumor, importInArticleCategory } from "@/api/man";
import { fileChange } from "../../components/importExportCommon";

export default {
  name: "rumorList",
  data() {
    return {
      form: {
        seqNumber: '',
        title: '',
        submissionTime:''
      },
      // 列表数据
      pgcQaList:[],
      // 分页
      paginationDataProduct: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      dialogVisible: false,
      addEditDVisible: false,
      uploadShow: false,
      // 业务ID列表
      contentBusinesses: [],
      // 选中的业务id
      contentBusinessId:'',
      // 当前选中的谣言
      curRumor: {},
      // 添加谣言标识
      addFlag: false,
    }
  },
  components: {
    breadCrumb,
    pagination
  },
  created() {
    queryContentUserManInfo({
      tenantId: this.$commonJs.getTenantId(),
    }).then(res => {
      console.log("🚀 ~ file: rumorList.vue:130 ~ created ~ res:", res)
      if (res) {
        this.contentBusinesses = res.contentBusinesses;
      }
    })
  },
  methods: {
    // 获取数据
    getPageRumor(val) {
      if (!this.contentBusinessId) {
        this.$message({
          message:'请先选择业务ID，再对谣言进行处理操作',
          type: 'error'
        })
        return;
      }
      if (val) {
        this.paginationDataProduct.currentPage = val;
      }

      rumorPageRumor({
        pageSize: this.paginationDataProduct.pageSize || 10,
        pageNo: this.paginationDataProduct.currentPage || 1,
        beginTime: this.form?.submissionTime[0]?.trim() || '',
        endTime: this.form?.submissionTime[1]?.trim() || '',
        tenantId: this.$commonJs.getTenantId(),
        contentBusinessIds: [this.contentBusinessId],
        ...this.form
      }).then(res => {
        console.log("🚀 ~ file: pgcQa.vue:107 ~ getPageRumor ~ res:", res)
        this.pgcQaList = res.data;
        this.paginationDataProduct.total = res.totalCount;
        this.paginationDataProduct.currentPage = res.pageNo;
        this.paginationDataProduct.pageSize = res.pageSize;
      }).catch((err) => {
        this.pgcQaList = [];
        this.$message({
          message: err?.msg || '',
          type: 'error'
        })
      })
    },
    // 搜索
    onSumit() {
      console.log('form', this.form)
      this.paginationDataProduct.currentPage = 1;
      this.getPageRumor();
    },
    // 重置
    reset(){
      this.form = {
        seqNumber: '',
        title: '',
        submissionTime:''
      }
      this.paginationDataProduct.currentPage = 1;
    },
    // 切换页码
    paginationChangeProduct(val) {
      this.paginationDataProduct = val;
      console.log('paginationChangeProduct', this.paginationDataProduct)
      this.getPageRumor()
    },
    // 上传弹窗关闭
    closeDialog() {
      let fileVal = this.$refs.file;
      fileVal.value = ""
      this.fileResult = "";
      this.fileName = "";
      this.dialogVisible = false;
    },
    // 关闭谣言弹窗
    closeADDialog(){
      this.addEditDVisible = false;
      this.curRumor = {};
    },
    // 下载模板
    downloadDiles() {
      window.location.href = 'https://storage.360buyimg.com/cms-bucket/rumor/rumor_%E8%B0%A3%E8%A8%80%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF_20251209.xlsx?Expires=3912747010&AccessKey=Jd9HhkNEAtwojp2B&Signature=cAlov5j22rAf%2BzQM%2B2eFSKblMwI%3D'
    },
    // 上传文件校验
    async fileChange(e) {
        fileChange(e, this, 5);
      },
    // 上传
    uploadContentSkusExl(){
      if (!this.contentBusinessId) {
        this.$message({
          message:'请先选择业务ID，再对谣言进行处理操作',
          type: 'error'
        })
        return;
      }
      let file = this.fileName
        if (file == "" || !file) {
          this.$message.error('请选择上传的文件');
          return false
        } else {
          this.uploadShow = true
          this.$message({
            message: '文件上传中，请勿刷新页面和关闭窗口！',
            type: 'warning'
          });
        }
        importInArticleCategory({
          tenantId: this.$commonJs.getTenantId(),
          businessId: this.contentBusinessId,
          fileBase64: this.fileBase64,
          fileName: file.name.split(".")[0],
          importExportCode: 10
        }).then(res=>{
          console.log('pgcImportQuestionAndAnswer', res);
          if(res) {
            this.uploadShow = false;
            this.closeDialog();
            this.$message({
              message: '上传成功',
              type:'success'
            })
            this.getPageRumor();
          }
        }).catch(e=>{
          console.log(e);
        })
    },
    // 选择业务id
    changeSelect(row){
      this.contentBusinessId = row;
    },
    // 查看谣言
    handleClick(row) {
      console.log("🚀 ~ file: pgcQa.vue:142 ~ handleClick ~ row:", row)
      this.addEditDVisible = true;
      this.curRumor = {...row, answer: String(row.answer) };
    },
    // 批量上传
    multiUpload() {
      this.dialogVisible = true;
    },
    // 添加谣言
    addRumor() {
      this.addFlag = true;
      this.addEditDVisible = true;
    },
    // 执行添加或修改
    onSubmit() {
      if (!this.contentBusinessId) {
        this.$message({
          message:'请先选择业务ID，再对谣言进行处理操作',
          type: 'error'
        })
        return;
      }
      if (this.addFlag) {
        // 添加新谣言
        rumorSaveRumor({
          tenantId: this.$commonJs.getTenantId(),
          contentBusinessId: this.contentBusinessId,
          ...this.curRumor
        }).then(res => {
          console.log("🚀 ~ file: rumorList.vue:318 ~ onSubmit ~ res:", res)
          if (res) {
            this.$message({
              message: '添加成功',
              type: 'success'
            })
            this.addFlag = false;
            this.addEditDVisible = false;
            this.curRumor = {}
            this.getPageRumor();
          }
        }).catch(err => {
          this.$message({
            message: err.msg,
            type: 'error'
          })
        } )
      } else {
        // 修改谣言
        rumorUpdateRumor({
          tenantId: this.$commonJs.getTenantId(),
          contentBusinessId: this.contentBusinessId,
          ...this.curRumor
        }).then(res => {
          console.log("🚀 ~ file: rumorList.vue:328 ~ onSubmit ~ res:", res)
          if (res) {
            this.$message({
              message: '修改成功',
              type: 'success'
            })
            this.addFlag = false;
            this.addEditDVisible = false;
            this.curRumor = {};
            this.getPageRumor();
          }
        })
      }
    },
    onCancle() {
      this.addFlag = false;
      this.addEditDVisible = false;
      this.curRumor = {}
    },
    // 图片加载错误处理
    handleImageError() {
      console.log('图片加载失败');
    }
  }
};
</script>

<style lang="scss" scoped>
.rumor-search-box {
  padding: 10px 0 ;
  margin-bottom: 10px;
  background: #fff;
  p {
    font-size: 14px;
    color: red;
    margin: 0 0 10px 37px;
  }
  .rumor-search{
    display: flex;
    align-items: center;
    .el-form-item {
      margin-bottom: 0;
    }
  }
}

// 图片预览样式
.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
  font-size: 14px;
}
</style>
